export default "__VITE_ASSET__Cu9t4C_5__"